type DossierWithLibelle = {
    numero?: string | null;
    societeDenomination?: string | null;
    clientOpereLibelle?: string | null;
};

export const getDossierLibelle = (dos: DossierWithLibelle): string => {
    if (!dos?.numero) return 'Légale Société';

    const isV1 = dos.numero.startsWith('LDF');
    return isV1
        ? (dos.societeDenomination ?? 'Légale Société')
        : (dos.clientOpereLibelle ?? dos.societeDenomination ?? 'Légale Société');
};
